<template lang="html">
  <section class="dashboard">
    <!-- <div class="row">
      <div class="col-xl-4 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-cube text-danger icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Incidents Closed</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">
                    {{ incidentsClosed }}
                  </h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i>
              In total
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-receipt text-warning icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Incidents Submitted</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">
                    {{ incidentsSubmitted }}
                  </h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-bookmark-outline mr-1" aria-hidden="true"></i>
              In total
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-poll-box text-teal icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Ratio</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">
                    <span :class="ratioClass">{{ formattedRatio }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-calendar mr-1" aria-hidden="true"></i>
              Report Closing Ratio
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-6 grid-margin">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4">Incidents By Month</h5>
            <ve-histogram
              :legend-visible="false"
              v-if="incidentsByMonthChartData"
              :data="incidentsByMonthChartData"
            ></ve-histogram>
            <span class="text-muted" v-if="!incidentsByMonthChartData"
              >No data available</span
            >
          </div>
        </div>
      </div>
      <div class="col-6 grid-margin">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4">Incidents By Location</h5>
            <ve-histogram
              :legend-visible="false"
              v-if="incidentsByLocationChartData"
              :data="incidentsByLocationChartData"
            ></ve-histogram>
            <span class="text-muted" v-if="!incidentsByLocationChartData"
              >No data available</span
            >
          </div>
        </div>
      </div>
      <div class="col-6 grid-margin">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4">Incidents By Causal Codes</h5>
            <ve-histogram
              :legend-visible="false"
              v-if="incidentsByCausalCodesChartData"
              :data="incidentsByCausalCodesChartData"
            ></ve-histogram>
            <span class="text-muted" v-if="!incidentsByCausalCodesChartData"
              >No data available</span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { companiesCollection } from '@/firebaseConfig.ts';
import VeHistogram from 'v-charts/lib/histogram.common.js';

export default {
  name: 'HelloWorld',
  components: {
    VeHistogram,
  },
  data() {
    return {
      companyId: '',
      incidentsClosed: 0,
      incidentsSubmitted: 0,
      incidentsByMonth: null,
      incidentsByLocation: null,
      incidentsByCausalCodes: null,
      ratio: 0,
    };
  },

  computed: {
    incidentsByMonthChartData() {
      if (this.incidentsByMonth) {
        const rows = [];
        const months = Object.keys(this.incidentsByMonth);
        for (let month of months) {
          rows.push({
            month: month,
            submissions: this.incidentsByMonth[month],
          });
        }
        return {
          columns: ['month', 'submissions'],
          rows: rows,
        };
      }
      return null;
    },

    incidentsByLocationChartData() {
      if (this.incidentsByLocation) {
        const rows = [];
        const locations = Object.keys(this.incidentsByLocation);
        for (let location of locations) {
          rows.push({
            location: location,
            submissions: this.incidentsByLocation[location],
          });
        }
        return {
          columns: ['location', 'submissions'],
          rows: rows,
        };
      }
      return null;
    },

    incidentsByCausalCodesChartData() {
      if (this.incidentsByCausalCodes) {
        const rows = [];
        const codes = Object.keys(this.incidentsByCausalCodes);
        for (let code of codes) {
          rows.push({
            code: code,
            submissions: this.incidentsByCausalCodes[code],
          });
        }
        return {
          columns: ['code', 'submissions'],
          rows: rows,
        };
      }
      return null;
    },

    formattedRatio() {
      if (this.ratio >= 0) {
        return (this.ratio * 100).toFixed(2) + ' %';
      } else {
        return '-';
      }
    },

    ratioClass() {
      if (this.ratio > 0.5) {
        return 'text-danger';
      }
      if (this.ratio > 0.1) {
        return 'text-primary';
      }
      if (this.ratio >= 0) {
        return 'text-success';
      }
      return '';
    },
  },

  async mounted() {
    this.companyId = this.$store.getters.companyId;
    const docRef = await companiesCollection
      .doc(this.companyId)
      .onSnapshot(snapshot => {
        if (snapshot.exists) {
          const data = snapshot.data();
          console.log('Stats', data);
          if (data) {
            this.incidentsClosed = data['totalIncidentsClosed'] || 0;
            this.incidentsSubmitted = data['totalIncidentsSubmitted'] || 0;
            if (this.incidentsSubmitted > 0) {
              this.ratio = this.incidentsClosed / this.incidentsSubmitted;
            }
            const year = new Date().getFullYear();
            let incidents = data['incidentsByTime'];
            if (incidents) {
              if (incidents.hasOwnProperty(year)) {
                console.log('Yes', incidents[year]);
                this.incidentsByMonth = incidents[year];
              }
            }
            let locations = data['incidentsByLocation'];
            if (locations) {
              console.log('Locaitons', locations);
              this.incidentsByLocation = locations;
            }
            let codes = data['incidentsByCausalCodes'];
            if (codes) {
              console.log('Codes', codes);
              this.incidentsByCausalCodes = codes;
            }
          }
        }
      });
  },
};
</script>

<style scoped lang="scss"></style>
